import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { getIsContentManager, getIsTeacher } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { getCurrentTeamLevel } from 'common.components/user/selectors';
import * as courseSelectors from 'store/courses/selectors';
import { getSubjectConfigList } from 'store/subject-config/selectors';

import {
    getIsDraftsLoading,
    getIsActiveLessonsLoading,
    getIsAssignedLessonsLoading,
    getIsCompletedLessonsLoading,
} from './lessons.selectors';

/**
 * @typedef {Object} PropWithCourseId
 * @property {Number} courseId
 **/

/**
 * @typedef {Object} PropWithCourseIdAndClassId
 * @property {Number} courseId
 * @property {Number} classId
 **/

export const getIsAnythingLoading = createSelector(
    [
        courseSelectors.getSubjects,
        courseSelectors.getCoursesLoadingStatus,
        getIsDraftsLoading,
        getIsAssignedLessonsLoading,
        getIsActiveLessonsLoading,
        getIsCompletedLessonsLoading,
        courseSelectors.getIsLessonCountsLoading,
    ],
    /* eslint-disable max-params */
    (
        subjects,
        coursesLoadingStatus,
        isDraftsLoading,
        isAssignedLoading,
        isActiveLoading,
        isCompleteLoading,
        isLessonsCountsLoading
    ) => {
        return (
            coursesLoadingStatus === LOADING_STATUSES.LOADING ||
            isDraftsLoading ||
            isAssignedLoading ||
            isActiveLoading ||
            isCompleteLoading ||
            isLessonsCountsLoading
        );
    }
    /* eslint-enable max-params */
);

/**
 * Returns true, if course is loaded
 * @param course
 * @param {{courseId: number}} props
 * @return {Boolean}
 */
export const getShouldShowContent = createSelector(
    [courseSelectors.getCourseByClassAndId, courseSelectors.getIsLessonCountsLoading],
    (course, isLessonCountsLoading) => {
        return Boolean(course && !isLessonCountsLoading);
    }
);

/**
 * returns true, if user can edit lessons
 * @param {Object} storeState
 * @return {Boolean}
 */
export const getCanEditLessons = createSelector(
    [getIsContentManager, getIsTeacher],
    (isCM, isTeacher) => isCM || isTeacher
);

/**
 * returns true, if lessons count loading
 * @param {Object} storeState
 * @param {{courseId: number}} props
 * @return {Boolean}
 */
export const getIsLessonsCountLoading = createSelector(
    [courseSelectors.getLessonsCountLoadingStatus],
    (loadingStatus) => loadingStatus === LOADING_STATUSES.LOADING
);

export const getShouldShowSkillStats = createSelector(
    [getSubjectConfigList, getCurrentTeamLevel, courseSelectors.getCourseByClassAndId],
    (subjectsConfig, grade, course) => {
        const subject = course?.subject;

        if (!subject || !grade) {
            return false;
        }

        return subjectsConfig.some(
            (subjectConfig) =>
                subjectConfig.subject === subject && subjectConfig.grades_with_skill_stats?.includes(grade)
        );
    }
);
